import {memo, useEffect} from 'react'
import type {ProgressiveDiffEntry} from '../../types/progressive-diff-types'
import {DiffEntryLoadingSkeleton} from './DiffEntryLoadingSkeleton'
import type {ProgressiveDiffManager} from '../../hooks/use-progressive-diff-manager'

export const EagerDiffEntryLoadingSkeleton = memo(function EagerDiffEntryLoadingSkeleton({
  progressiveDiffEntry,
  loadMore,
}: {
  progressiveDiffEntry: ProgressiveDiffEntry
  loadMore: ProgressiveDiffManager['loadMore']
}) {
  useEffect(() => {
    const abortController = new AbortController()

    loadMore({startingAt: progressiveDiffEntry, signal: abortController.signal})

    return () => {
      abortController.abort()
    }
  }, [loadMore, progressiveDiffEntry])

  return (
    <DiffEntryLoadingSkeleton
      ariaLabel={`Loading ${progressiveDiffEntry.path}`}
      testId={`eager-load-${progressiveDiffEntry.path}`}
      id={`diff-${progressiveDiffEntry.pathDigest}`}
    />
  )
})

try{ EagerDiffEntryLoadingSkeleton.displayName ||= 'EagerDiffEntryLoadingSkeleton' } catch {}